import {dateTimeManager} from "../../services/TimeManager2";

const state = {
    activeTab: 2, // Set default to 2 (This Month) instead of 1 (This Year)
    globalDateRange: dateTimeManager.getThisMonthRange() // Set default date range to This Month
};

const mutations = {
    setActiveTab : (state, data) => state.activeTab = data,
    setGlobalDateRange : (state, data) => state.globalDateRange = data,
};

const getters = {
    getActiveTab : state => state.activeTab,
    getGlobalDateRange : state => state.globalDateRange,
};

export default {
    state,
    mutations,
    getters
}
